import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL3 } from '../Config/Base';
import { BASE_URL } from '../Config/Base';
import { Oval } from  'react-loader-spinner'

const OatCategoryMain = () => {
  return (
    <>
    
    <div className='oat-addmain'>
      
    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
       <div className="oat-addgrid-layout">
    
    <div className="oat-addmain-top">
      
      <span className='OatTitle'>
      <span>CATEGORIES</span></span>
      <div className='oat-addmain-back'>
      <Link to="/Oatsection"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i><br></br><span>Back</span></Link>
      </div> 
     
      </div>
      </div>
      <div id="OatCategory_div">

      <ul id="OatCatogory_ul">
    <li id="OatCatogory_liA">
        <div class="icon" id="OatCatogory_icon"><Link to="/OatSkill"><i class="fa fa-cogs" id="OatCategory_iA"></i></Link></div>
        <div class="title" id="OatCatogory_title">SKILL</div>
        
    </li>
    <li id="OatCatogory_liB">
        <div class="icon" id="OatCatogory_icon"><Link to="/OatEducation"><i class="fa fa-graduation-cap" id="OatCategory_iB"></i></Link></div>
        <div class="title" id="OatCatogory_title">EDUCATION</div>
        
    </li>
    <li id="OatCatogory_liC">
        <div class="icon" id="OatCatogory_icon"><Link to="/OatDesignation"><i class="fa fa-building" id="OatCategory_iC"></i></Link></div>
        <div class="title" id="OatCatogory_title">DESIGNATION</div>
        
    </li>
    <li id="OatCatogory_liD">
        <div class="icon" id="OatCatogory_icon"><Link to="/OatDepartment"><i class="fa fa-sitemap" id="OatCategory_iD"></i></Link></div>
        <div class="title" id="OatCatogory_title">DEPARTMENT</div>
        
    </li>
    
</ul>
      </div>
      
    </div>
    </>
  )
}

export default OatCategoryMain
